/**
 * DefinitionSelectControl - Select dropdown with edit button for definition endpoints.
 * Used by RepeaterNode's definition selector. The edit button navigates into
 * definition-edit mode (~def/DefinitionId).
 */

import { useNavigate, useParams } from 'react-router-dom';
import { SelectControl } from './SelectControl';

interface DefinitionSelectControlProps {
  value: string;
  options: string[];
  color: string;
  onChange: (value: string) => void;
}

export function DefinitionSelectControl({ value, options, color, onChange }: DefinitionSelectControlProps) {
  const navigate = useNavigate();
  const { sessionId, projectName, draftId } = useParams();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!value) return;
    const urlBase = draftId
      ? `/${sessionId}/new/${draftId}`
      : `/${sessionId}/project/${encodeURIComponent(projectName!)}`;
    navigate(`${urlBase}/~def/${value}`, { replace: true });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4, width: '100%' }}>
      <SelectControl
        value={value ?? options[0]}
        options={options}
        color={color}
        onChange={onChange}
      />
      {value && (
        <button
          className="nodrag nopan"
          onClick={handleEdit}
          style={{
            background: '#374151',
            border: '1px solid #4b5563',
            borderRadius: 3,
            color: '#9ca3af',
            fontSize: 11,
            padding: '1px 5px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            lineHeight: '16px',
          }}
          title={`Edit ${value} definition`}
        >
          &#9998;
        </button>
      )}
    </div>
  );
}
